<template>
  <div id="terms" class="contenedor">
    <!--<TopMenu></TopMenu>-->
    <!--<NavbarLogotipo></NavbarLogotipo>-->
    <v-container fluid class="containerwithoutback base text-center ma-0 mt-10 px-0 pt-6 pb-0">
      <v-row no-gutters class="titulo "></v-row>
      <v-row no-gutters class="datos pb-0" style="height: 70vh !important">
        <v-col cols="12" sm="12">
          <h3>Términos y Condiciones de Uso del Sitio Web PeopleEnEspañol.com</h3>
          <p>
            Los siguientes términos y condiciones (los "Términos y Condiciones") rigen el uso
            que usted le de a este sitio web y a cualquier de los contenidos disponibles por o atráves
            de este sitio web, incluyendo cualquier contenido derivado del mismo(el "Sitio Web"). Time Inc.("Time Inc."
            o "nosotros") ha puesto a su disposición el Sitio Web. Podemos cambiar los Términos y Condiciones de vez
            en cuando en cualquier momento sin ninguna notificación, solo publicando los cambios en el Sitio Web. AL USAR EL SITIO WEB,
            USTED ACEPTA Y ESTE DE ACUERDO CON ESTOS TÉRMINOS Y CONDICIONES EN LO QUE SE REFIERE A SU USO DEL SITIO WEB.
            Si usted no esta de acuerdo con estos Términos y Condiciones, no puede tener acceso al mismo ni usar el Sitio Web
            de ninguna otra manera.
          </p>
          <p>
            1. Derecho de Propiedad Entre usted y Time Inc., Time Inc. es dueño unico y exclusivo de todos los derechos,
            titulo e interes en y del Sitio Web, de todo el contenido(Incluyendo, por ejemplo, audio,fotograías, ilustraciones, gráficos
            otros medios visuales, videos, copias, textos, software, titulos, archivos de Onda de Choques, etc.), códigos, datos
            y materiales del mismo, el aspecto y el ambiente, el diseño y la organización del Sitio Web y la compilación de los
            contenidos, códigos, datos y los materiales en el Sitio Web, incluyendo pero no limitado a, cualesquiera derechos de autor.
          </p>
        </v-col>
      </v-row>
      <v-row class="terminos mb-0">
        <v-col cols="12" sm="12">
          <input
            type="checkbox"
            id="terminos"
            name="terminos"
            value="terminos"
            v-model="check"
            @click="check=true"
          />
          <label for="terminos">Acepto Terminos y condiciones</label>
          <br />
          <button type="submit" class="boton" @click="validar()">Siguiente</button>
        </v-col>
      </v-row>
    </v-container>

    <!--Confirmación de datos-->
    <v-dialog v-model="confirmation" width="400">
      <v-card>
        <v-card-title class="orange white--text">
          <span class="headline">Términos y Condiciones</span>
        </v-card-title>
        <v-card-text>
          <br />
          <h3
            class="text-sm-center text-md-center text-lg-center"
          >Es necesario aceptar términos y condiciones para continuar con la instalación.</h3>
          <br />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" text @click="confirmation=false    ">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import TopMenu from "@/components/TopMenu.vue";
import Sidebar from "@/components/Sidebar.vue";
export default {
  components: {
    Sidebar,
  },
  data() {
    return {
      step: "Instalador de nuevo cliente",
      stepn: "1-N",
      check: false,
      confirmation: false,
    };
  },
  methods: {
    nombre() {
      (localStorage.step = this.step), (localStorage.stepn = this.stepn);
    },
    validar() {
      if (this.check == true) {
        this.$router.push("/admin");
      }else{
      this.confirmation = true;
      }
    },
  },
  created() {
    this.nombre();
  },
};
</script>
